<template>
  <div class="home_container">
    <div class="top_border"></div>
    <welcomeScreen />
    <fullImage v-if="imageState"/>
    <modalImage v-if="showImage"/>
    <Navigation/>
    <Slider/>
    <Info/>
    <About/>
    <Realisations/>
    <Offer/>
    <ContactUs/>
    <Footer/>
    <backTop/>
  </div>
</template>

<script>
import Navigation from '../components/navigation.vue';
import Slider from '../components/slider.vue';
import Info from '../components/Info.vue';
import About from '../components/About.vue';
import Realisations from '../components/Realisations.vue';
import Offer from '../components/Offer.vue';
import fullImage from '../components/fullImage.vue';
import ContactUs from '../components/ContactUs.vue';
import Footer from '../components/Footer.vue';
import backTop from '../components/backTop.vue';
import welcomeScreen from '../components/welcomeScreen.vue';
import modalImage from '../components/modalImage.vue';
import { mapState, mapMutations } from 'vuex';
export default {
  name: 'home',
  components: {
    Navigation,
    modalImage,
    Slider,
    Info,
    About,
    Realisations,
    Offer,
    fullImage,
    ContactUs,
    Footer,
    backTop,
    welcomeScreen,
  },
  computed:{
    ...mapState({
      imageState: state=> state.realisations.imageState,
      firstVisit: state=> state.firstVisit,
      showImage: state => state.gridGallery.showImage
    })
  },
  methods:{
    ...mapMutations(['bindTexts'])
  },
  mounted(){
    this.bindTexts();
  }
}
</script>
<style lang="scss" scoped>
  .home_container{
    width: 100%;
    height: 100vh;
  }
  @media (min-width:1440px){
    .top_border{
      border-top: 10px solid darkcyan;
      margin: 0 100px;
    }
  }
</style>
